/**
 * Access helpers for admin-panel module gating.
 * Tolerates common backend shapes: role, is_staff, is_superuser, permissions[].
 *
 * Explicit end-user roles are denied. Everyone else authenticated in this
 * admin portal (admin / staff / unspecified staff profile) is allowed.
 */
export const isAdminUser = (user) => {
  if (!user || typeof user !== 'object') return false;

  const role = String(user.role ?? user.user_type ?? user.userType ?? '').toLowerCase();
  const endUserRoles = new Set([
    'client',
    'customer',
    'dermatologist',
    'retailer',
    'retailer_owner',
    'user',
  ]);
  if (role && endUserRoles.has(role)) return false;

  if (['admin', 'superadmin', 'super_admin', 'super-admin', 'manager'].includes(role)) {
    return true;
  }

  if (user.is_staff === true || user.is_superuser === true || user.is_admin === true) {
    return true;
  }

  const permissions = user.permissions;
  if (Array.isArray(permissions) && permissions.length > 0) {
    return true;
  }

  // Authenticated admin-panel session with no explicit end-user role
  return !role;
};
